(() => {
  'use strict';
  const VERSION = '1.1.0';
  if (window.BNImageTextElite?.version === VERSION) {
    window.BNImageTextElite.scan(document);
    return;
  }

  const states = new WeakMap();

  const init = (root) => {
    if (!root || states.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
    const entry = root.dataset.bnEntryAnimation || 'none';
    const mediaItem = root.querySelector('.image-with-text__media-item');
    let observer = null;
    let touchTimer = 0;

    const reveal = () => requestAnimationFrame(() => root.classList.add('is-visible'));
    if (entry !== 'none' && 'IntersectionObserver' in window) {
      root.classList.add('bn-iwt-motion-armed');
      root.classList.toggle('bn-iwt-reduced-motion', reduced);
      root.classList.remove('is-visible');
      observer = new IntersectionObserver((entries) => {
        if (entries.some((item) => item.isIntersecting)) {
          reveal();
          observer?.disconnect();
          observer = null;
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });
      requestAnimationFrame(() => requestAnimationFrame(() => observer?.observe(root)));
    } else {
      reveal();
    }

    const interact = () => {
      if (!mediaItem || root.dataset.bnMediaInteraction === 'none') return;
      mediaItem.classList.remove('is-interacted');
      void mediaItem.offsetWidth;
      mediaItem.classList.add('is-interacted');
      window.clearTimeout(touchTimer);
      touchTimer = window.setTimeout(() => mediaItem.classList.remove('is-interacted'), 760);
    };

    mediaItem?.addEventListener('pointerup', (event) => {
      if (event.pointerType === 'touch' || event.pointerType === 'pen') interact();
    }, { signal });

    states.set(root, {
      destroy() {
        observer?.disconnect();
        window.clearTimeout(touchTimer);
        controller.abort();
        states.delete(root);
      }
    });
  };

  const scan = (scope = document) => {
    const roots = [];
    if (scope.matches?.('[data-bn-image-text]')) roots.push(scope);
    scope.querySelectorAll?.('[data-bn-image-text]').forEach((node) => roots.push(node));
    roots.forEach(init);
  };
  const unload = (scope) => {
    if (!scope) return;
    const roots = [];
    if (scope.matches?.('[data-bn-image-text]')) roots.push(scope);
    scope.querySelectorAll?.('[data-bn-image-text]').forEach((node) => roots.push(node));
    roots.forEach((root) => states.get(root)?.destroy());
  };

  window.BNImageTextElite = { version: VERSION, scan, unload };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
})();
